module.exports = __webpack_public_path__ + "media/homepage/organzie-and-manage_@2x-74890f58.png";